<template>
    <div>
        <loading :active.sync="loadingApp" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{name:'transaction.index'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Detail Transaksi</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" class="pb-2" v-if="loadingApp == false">
            <div class="section detail-transaction-section pt-4" style="--height:150px;">
                <div class="detail-card">
                    <div class="listed-detail mt-1">
                        <div class="icon-wrapper" v-if="transaction.status == 'PENDING'">
                            <div class="iconbox bg-warning">
                                <ion-icon name="refresh-outline"></ion-icon>
                            </div>
                        </div>
                        <div class="icon-wrapper" v-if="transaction.status == 'PAID'">
                            <div class="iconbox bg-success">
                                <ion-icon name="checkmark-outline"></ion-icon>
                            </div>
                        </div>
                        <div class="icon-wrapper" v-if="transaction.status == 'FAILED'">
                            <div class="iconbox bg-danger">
                                <ion-icon name="close-outline"></ion-icon>
                            </div>
                        </div>
                        <div class="icon-wrapper" v-if="transaction.status == 'HOLDON'">
                            <div class="iconbox bg-primary">
                                <ion-icon name="pause-outline"></ion-icon>
                            </div>
                        </div>
                        <h2 class="text-center mt-2 mb-1">{{ transaction.product_name }}</h2>
                        <h3 class="text-center">{{ transaction.no_pelanggan }}</h3>
                    </div>
                    <div class="listed-detail mt-1">
                        <dd class="mb-0">ID Transkasi <b>#{{ transaction.id }}</b></dd>
                        <dd class="mb-0">Status Transkasi<br>
                            <div class="chip chip-warning" v-if="transaction.status == 'PENDING'">
                                <span class="chip-label">Pending</span>
                            </div>
                            <div class="chip chip-success" v-if="transaction.status == 'PAID'">
                                <span class="chip-label">Berhasil</span>
                            </div>
                            <div class="chip chip-danger" v-if="transaction.status == 'FAILED'">
                                <span class="chip-label">Gagal</span>
                            </div>
                            <div class="chip chip-primary" v-if="transaction.status == 'HOLDON'">
                                <span class="chip-label">Holdon</span>
                            </div>
                        </dd>
                        <dd class="mb-0"><small>Tanggal {{ transaction.created_at }}</small></dd>
                    </div>
                    <div class="listed-detail mt-1">
                        <blockquote class="blockquote p-1 mt-2 mb-1">
                            <p class="mb-0"><ion-icon name="alert-circle"></ion-icon> Detail Tagihan</p>
                        </blockquote>
                        <table>
                            <tr>
                                <td class="text-nowrap" width="130px">Produk</td>
                                <td width="20px">:</td>
                                <td><b>{{ transaction.product_name }}</b></td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">No. Pelanggan</td>
                                <td width="20px">:</td>
                                <td>{{ transaction.no_pelanggan }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Nama</td>
                                <td width="20px">:</td>
                                <td>{{ transaction.nama_pelanggan }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Bulan/Tahun</td>
                                <td width="20px">:</td>
                                <td>{{ transaction.bill_periode }}</td>
                            </tr>
                            <tr v-for="(item,index) in detail" :key="index">
                                <td class="text-nowrap" width="130px">{{item.key}}</td>
                                <td width="20px">:</td>
                                <td>{{ item.value }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Jml. Tagihan</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.bill_tagihan | rupiah }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Admin Bank</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.bill_admin | rupiah }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Total Tagihan</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.bill_total_tagihan | rupiah }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">No. Refferensi</td>
                                <td width="20px">:</td>
                                <td style="word-wrap: break-word">{{ transaction.serial_number }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="listed-detail mt-1" style="border-bottom:0px;">
                        <blockquote class="blockquote p-1 mt-2 mb-1">
                            <p class="mb-0"><ion-icon name="alert-circle"></ion-icon> Detail Pembayaran</p>
                        </blockquote>
                        <table>
                            <tr>
                                <td class="text-nowrap" width="130px">Biaya Outlet</td>
                                <td width="20px">:</td>
                                <td style="display: inline-flex;">
                                    Rp {{ transaction.biaya_outlet | rupiah }} 
                                    <a href="Javascript:;" v-if="transaction.status == 'PAID'" class="ml-1" style="font-size:20px;" @click="actionSheetBiayaOutlet('show')">
                                        <ion-icon name="create-outline"></ion-icon>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Total Bayar</td>
                                <td width="20px">:</td>
                                <td><b>Rp {{ transaction.jumlah_bayar | rupiah }}</b> (Total yang harus di bayarkan pelanggan Anda)</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Saldo Terpotong</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.bill_total_bayar | rupiah }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Cashback</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.cashback | rupiah }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">Profit Penjualan</td>
                                <td width="20px">:</td>
                                <td class="text-success">Rp {{ transaction.bill_fee + transaction.biaya_outlet | rupiah }}</td>
                            </tr>
                        </table>
                        
                    </div>
                    <div class="listed-detail" style="border-bottom:0px;" v-if="transaction.status == 'PAID'">
                        <a :href="'https://play.google.com/store/apps/details?id='+VUE_ENV.VUE_APP_PACKAGENAME_APK" target="_blank" class="btn btn-dark btn-block">
                            <ion-icon name="logo-google-playstore"></ion-icon> Beri Rating
                        </a>
                        <a :href="'https://api.whatsapp.com/send?text='+message" target="_blank" class="btn btn-success btn-block">
                            <ion-icon name="logo-whatsapp"></ion-icon> Kirim Laporan Transkasi
                        </a>
                        <button class="btn btn-primary btn-block" @click="print()"><ion-icon name="print"></ion-icon> Print Struk</button>
                        <button class="btn btn-primary btn-block" @click="coming()"><ion-icon name="cloud-download"></ion-icon> Download Struk</button>
                    </div>
                </div>
            </div>
        </div>

        <action-sheet ref="edit_biaya_outlet" :title="'Ubah Biaya Outlet'" :inset="true">
            <div class="form-group basic">
                <label class="label">Set Biaya Outlet</label>
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Rp</span>
                    </div>
                    <input type="tel" class="form-control form-control-sm" v-model="biaya_outlet" @input="inputBiayaOutlet">
                </div>
                <small class="text-danger" v-if="errors.biaya_outlet"><i>{{ errors.biaya_outlet[0] }}</i></small>
            </div>
            <div class="form-group basic">
                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-secondary btn-block" @click="actionSheetBiayaOutlet('hide')"> Batal</button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary btn-block'" @click.native="updateBiayaOutlet()">Simpan</ButtonLoader>
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import $axios from './../../../api.js'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            sender:[],
            transaction: {},
            loadingApp: true,
            loadingButton: false,
            biaya_outlet: '0',
            message: ''
        }
    },
    created() {
        this.getDetail(this.$route.params.id)
    },
    computed: {
        ...mapState(['errors','toast','VUE_ENV']),
        detail: function(){
            return JSON.parse(this.transaction.bill_detail);
        }
    },
    methods: {
        ...mapActions(['coming']),
        getDetail(id){
            $axios.get('/transaction/pascabayar/'+id)
            .then(response => {
                this.transaction = response.data.data
                this.loadingApp = false
                this.message = encodeURIComponent("Pembayaran Tagihan "+this.transaction.product_name+" ke "+this.transaction.no_pelanggan+" telah berhasil.\n\n"+
                                "Detail Tagihan : \n"+
                                "Tanggal : "+this.transaction.created_at+"\n"+
                                "No. Pel : "+this.transaction.no_pelanggan+"\n"+
                                "Nama : "+this.transaction.nama_pelanggan+"\n"+
                                "Bln/Thn : "+this.transaction.bill_periode+"\n"+
                                "Jml. Tagihan : Rp "+this.$options.filters.inputRupiah(this.transaction.bill_tagihan)+"\n"+
                                "Admin Bank : Rp "+this.$options.filters.inputRupiah(this.transaction.bill_admin)+"\n"+
                                "Biaya Outlet : Rp "+this.$options.filters.inputRupiah(this.transaction.biaya_outlet)+"\n"+
                                "Total Bayar : Rp "+this.$options.filters.inputRupiah(this.transaction.jumlah_bayar)+"\n"+
                                "No. Reff : "+this.transaction.serial_number+"\n\n"+
                                "Terima kasih atas kepercayaannya.");
                console.log(this.message)
            }).catch(() => {
                this.loadingApp = false
            })
        },
        actionSheetBiayaOutlet(value){
            if(value == 'show'){
                this.biaya_outlet =  this.$options.filters.inputRupiah(this.transaction.biaya_outlet)
            }
            let element = this.$refs.edit_biaya_outlet.$el
            window.$(element).modal(value)
        },
        inputBiayaOutlet(){
            this.biaya_outlet = this.$options.filters.inputRupiah(this.biaya_outlet)
        },
        updateBiayaOutlet(){
            this.loadingButton = true
            $axios.post('/transaction/prabayar/'+this.$route.params.id+'/update-biaya-outlet', {
                biaya_outlet: this.biaya_outlet
            })
            .then(() => {
                this.loadingButton = false
                this.actionSheetBiayaOutlet('hide')
                this.getDetail(this.$route.params.id)
                this.$store.commit('SET_TOAST', {show:true,message:'Berhasil',tipe:'default',icon:'success'})
            }).catch((error) => {
                this.actionSheetBiayaOutlet('hide')
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                this.loadingButton = false
                
            })
        },
        print(){
            if (typeof window.AndroidNative !== 'undefined') {
                window.AndroidNative.print();
            }
        },
    },
    destroyed() {
        this.$store.commit('CLEAR_ERRORS')
    },
    filters:{
        inputRupiah: function(value){
            value = value.toString()
            var number_string = value.replace(/[^,\d]/g, '').toString(),
            split   		= number_string.split(','),
            sisa     		= split[0].length % 3,
            rupiah     		= split[0].substr(0, sisa),
            ribuan     		= split[0].substr(sisa).match(/\d{3}/gi);

            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }

            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            return rupiah
        },
    }
}
</script>